module.exports = __webpack_public_path__ + "img/arrow-mobile.c1f4acb.svg";